import React from "react";

function Chat() {
  return (
    <div>
      <h1>Chat</h1>
    </div>
  );
}

export default Chat;
